import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import {
  FlexRowCenter,
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TextP } from '../../Defaults/Text';

interface Props {
  price: number | string;
  currency: string;
  text: string;
  oldPrice?: number | string;
}

function PriceInfo({ price, currency, text, oldPrice }: Props) {
  return (
    <PricesWrapper>
      <Wrapper>
        <Price>{`${price} ${currency}`}</Price>
        <SecondaryText>{text}</SecondaryText>
      </Wrapper>
      {oldPrice && +oldPrice > +price && (
        <Wrapper>
          <OldPrice>{`${oldPrice} ${currency}`}</OldPrice>
          <SecondaryText>{__('Spolu bez vernostnej zľavy')}</SecondaryText>
        </Wrapper>
      )}
    </PricesWrapper>
  );
}

const PricesWrapper = styled(FlexRowCenterVertical)`
  width: 100%;
`;

const Wrapper = styled(FlexCol)`
  justify-content: space-between;
  margin: ${rem(8)} 0 ${rem(24)};
  margin-right: ${rem(24)};

  &:last-child {
    margin-right: 0;
  }
`;

const Price = styled(TextP)`
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(30)};
  line-height: ${rem(36)};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-bottom: ${rem(4)};
  white-space: nowrap;
`;

const OldPrice = styled(Price)`
  text-decoration: line-through;
  font-size: ${rem(20)};
`;

const SecondaryText = styled(TextP)`
  font-family: ${({ theme }) => theme.font.tertiary};
  font-size: ${rem(12)};
  line-height: ${rem(20)};
  color: ${({ theme }) => theme.colors.placeholder};
`;

export { PriceInfo };
